import { ModalType } from '../../Modal';

const typeToDangerousContainerMap = {
    [ModalType.small]: ({ type, theme }) => ({
        background: theme.colors.white,
        overflowY: 'scroll',
        height: 'calc(100% - 10.5rem)',
        paddingRight: '1.3rem',
        lineHeight: '1.625rem',

        '> h2': {
            fontSize: '1.5rem',
            fontWeight: 'bold',
        },

        '::-webkit-scrollbar': {
            width: '0.25rem',
        },
        /* Track */
        '::-webkit-scrollbar-track': {
            background: theme.colors.bgGrey,
        },
        /* Handle */
        '::-webkit-scrollbar-thumb': {
            backgroundColor: theme.colors.fuchsia,
        },
    }),
    [ModalType.huge]: () => ({
        '> div > ul > li': {
            marginLeft: '2rem',
            lineHeight: '1.5rem',
        },
    }),
};

export const dangerousContainer = ({ type, theme }) => ({
    fontSize: '1.125rem',

    '> div > ol > li': {
        marginBottom: '2rem',
        paddingLeft: '1rem',
        lineHeight: '2rem',
    },

    ...typeToDangerousContainerMap[type]({ type, theme }),
});

export const link = ({ theme: { colors } }) => ({
    color: colors.blue,
    fontSize: '1.125rem',
    display: 'inline',
    textDecoration: 'underline',

    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) color 0.3s',
    willChange: 'color',

    ':hover': {
        color: colors.fuchsia,
    },
});
